module.exports = __webpack_public_path__ + "img/logo-m.fa20c7df.png";